exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".GoalDatesWarning{margin-top:2rem;margin-bottom:2rem;background-color:#fff7d6;border-radius:1rem;padding:1.5rem;display:flex;align-items:center;gap:1.5rem}.GoalDatesWarning .exclam{color:#ff6969}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/data/goal_dates_warning.scss
// module id = 1303
// module chunks = 0